import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import clinicalInsightImg from '../images/clinical-insight.png';
import continuousSupportImg from '../images/continuous-support.png';
import seamlessIntegrationImg from '../images/seamless-integration.png';
import trustedExtensionBg from '../images/trusted-extension-bg.png';

const HomePage = () => (
  <div className="home-page">
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-headline">Care Management, Reimagined for Clinical Continuity</h1>
          <p className="hero-subtext">Solace Care 360 partners with practices and health systems to build structured, nurse-led care management programs that strengthen outcomes, protect compliance, and extend care beyond the walls of the clinic.</p>
          <div className="hero-ctas">
            <Link to="/how-care-360-works" className="btn btn-primary">How Care 360 Works</Link>
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
          </div>
        </div>
      </div>
    </section>

    <section className="contact-cta-section">
      <div className="container">
        <h2 className="contact-cta-headline">Our 360 Approach</h2>
        <p className="contact-cta-subtext">Our model is built on structured clinical oversight, consistent patient engagement, and operational alignment — ensuring care management strengthens both patient outcomes and practice performance.</p>
      </div>
      <div className="approach-columns">
          <div className="approach-column approach-column-with-image">
            <div className="approach-column-image-wrap">
              <img src={clinicalInsightImg} alt="Healthcare professional and patient in telehealth consultation" className="approach-column-img" />
            </div>
            <div className="approach-column-content">
              <h3>Clinical Insight</h3>
              <p>Proactive assessments, early identification of change, and clearly defined escalation pathways — supporting safety, continuity, and informed decision-making.</p>
            </div>
          </div>
          <div className="approach-column approach-column-with-image-right">
            <div className="approach-column-content">
              <h3>Continuous Support</h3>
              <p>Consistent outreach between visits, reinforcing education, adherence, and engagement throughout the care journey.</p>
            </div>
            <div className="approach-column-image-wrap">
              <img src={continuousSupportImg} alt="Connected healthcare and continuous support" className="approach-column-img" />
            </div>
          </div>
          <div className="approach-column approach-column-with-image">
            <div className="approach-column-image-wrap">
              <img src={seamlessIntegrationImg} alt="Collaboration and seamless integration" className="approach-column-img" />
            </div>
            <div className="approach-column-content">
              <h3>Seamless Integration</h3>
              <p>End-to-end program support — from enrollment and documentation to compliance, reporting, and reimbursement — aligned with your clinical workflows and strategic goals.</p>
            </div>
          </div>
        </div>
    </section>

    <section className="approach-section trusted-extension-section" style={{ backgroundImage: `linear-gradient(to right, rgba(30, 107, 107, 0.88) 0%, rgba(30, 107, 107, 0.75) 100%), url(${trustedExtensionBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <div className="container">
        <h2 className="approach-title">A trusted extension of your clinical team</h2>
      </div>
      <div className="benefits-columns">
          <div className="benefits-column">
            <h3 className="benefits-column-title">Benefits for Practices</h3>
            <ul className="approach-list">
              {['Expands care beyond visit','Improved care coordination and continuity','Boosts patient engagement','Supports quality metrics and population health goals','Reduces clinical burden','Scales without added overhead','Delivered by experienced nurses','Optimizes reimbursement and program sustainability'].map((text,i)=>(
                <li key={i} className="approach-item">
                  <span className="approach-icon">✓</span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="benefits-column">
            <h3 className="benefits-column-title">Benefits for Patients</h3>
            <ul className="approach-list">
              {['Access to a dedicated nurse','Better understanding of their condition and plan','Proactive issue identification','Coordinated follow-up across providers','Stronger self-management skills','Reliable support between visits','Medication and treatment adherence support','Personalized care plan reinforcement'].map((text,i)=>(
                <li key={i} className="approach-item">
                  <span className="approach-icon">✓</span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
    </section>

    <section className="partner-section">
      <div className="container">
        <h2 className="partner-headline">Partner With Us</h2>
        <p className="partner-blurb">If you're looking for a trusted care management partner to support your patients, strengthen your care delivery model, and extend your clinical reach, Solace Care 360 is here to support your practice from every angle.</p>
        <Link to="/contact" className="btn btn-primary">Contact Us</Link>
      </div>
    </section>
  </div>
);

export default HomePage;
